import {UserOutlined,FacebookOutlined,EyeFilled,StarTwoTone,MessageTwoTone,CloseCircleTwoTone ,GoogleOutlined,QuestionCircleTwoTone,MinusSquareTwoTone   ,AimOutlined,MailOutlined ,PhoneOutlined,YoutubeOutlined,CheckCircleOutlined, InstagramOutlined, SearchOutlined,DeleteOutlined,CalendarOutlined, AlertTwoTone,  UsergroupAddOutlined,HddTwoTone,LeftOutlined,RightOutlined,ReconciliationTwoTone ,TrophyTwoTone  , UserAddOutlined,CalculatorOutlined,LaptopOutlined,MenuUnfoldOutlined ,IdcardTwoTone,SmileTwoTone,AppstoreTwoTone,InfoCircleOutlined, EditOutlined } from "@ant-design/icons";

export const DashboardIcon = <AppstoreTwoTone />;
export const UserIcon = <UserOutlined />;
export const SearchIcon = <SearchOutlined />;
export const userGroupIcon = <UsergroupAddOutlined />;
export const userAddIcon = <UserAddOutlined />;
export const calculatorIcon = <CalculatorOutlined />;
export const LaptopIcon = <LaptopOutlined />;
export const MenuIcon = <MenuUnfoldOutlined />;
export const idCardIcon = <IdcardTwoTone />;
export const deleteIcon = <DeleteOutlined style={{ color: "white" }} />;
export const trashIcon = <DeleteOutlined />;
export const smileIcon = <SmileTwoTone />;
export const DBIcon = <HddTwoTone />;
export const resourceIcon = <ReconciliationTwoTone />
export const trophyIcon = < TrophyTwoTone classID="trophy" />
export const leftSlide = <LeftOutlined />
export const rightSlide = <RightOutlined />
export const editIcon = <EditOutlined />
export const CalenderIcon = <CalendarOutlined />
export const upcomingInter = <AlertTwoTone />
export const facebookIcon = <FacebookOutlined />
export const instagramIcon =<InstagramOutlined />
export const youtubeIcon = <YoutubeOutlined />
export const emailIcon = <MailOutlined />
export const phoneIcon = <PhoneOutlined />
export const mapIcon = <AimOutlined />
export const messageIcon = <MessageTwoTone style={{marginLeft:"1vw"}} />
export const toggleIcon = <MinusSquareTwoTone />
export const closeIcon = <CloseCircleTwoTone />
export const eyeIcon = <EyeFilled />
export const questionIcon = <QuestionCircleTwoTone />
export const starIcon = <StarTwoTone twoToneColor="#e6a205" />
export const googleIcon = <GoogleOutlined style={{ fontSize: '40px', color: '#EA4335'}}/>
export const checkIcon = <CheckCircleOutlined style={{color:"grey",marginBottom:"15px",marginRight:"5px"}} />
export const errorSign = <InfoCircleOutlined style={{ color: '##FF0000' }} />